import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';

// Custom hook for carousel state management
var useCarouselState = function useCarouselState() {
  var _React$useState = React.useState({
      canScrollPrev: false,
      canScrollNext: false,
      current: 0,
      pages: 0
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    carouselState = _React$useState2[0],
    setCarouselState = _React$useState2[1];
  var updateCarouselState = React.useCallback(function (api) {
    if (!api) return;
    setCarouselState({
      canScrollPrev: api.canScrollPrev(),
      canScrollNext: api.canScrollNext(),
      current: api.selectedScrollSnap(),
      pages: api.scrollSnapList().length
    });
  }, []);
  return {
    carouselState: carouselState,
    updateCarouselState: updateCarouselState
  };
};

export { useCarouselState };
//# sourceMappingURL=useCarouselState.js.map
